import { getQueryLangFromTLang } from '@aqx-core/common/i18n/utils';

export const getLocalisedUrl = (url?: string | null): string | undefined => {
  if (!url) {
    return undefined;
  }

  const lang = getQueryLangFromTLang();
  try {
    const urlString = url.replace('{{language}}', lang);
    return new URL(urlString).toString();
  } catch (_err) {
    return undefined;
  }
};
